module.exports = __webpack_public_path__ + "img/ziliao_banner_tr.26aeea2f.jpg";